import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReverbService {
  private echo: Echo;

  constructor() {
    (window as any).Pusher = Pusher;
    this.echo = new Echo({
      broadcaster: 'reverb',
      key: environment.reverb.key,
      wsHost: environment.reverb.host,
      wsPort: environment.reverb.port,
      forceTLS: environment.reverb.forceTLS,
      enabledTransports: ['ws', 'wss'],
    });
  }

  listenToCallAnswered(userId: number): void {
    this.echo
      .private(`call.answered.${userId}`)
      .listen('CallAnswered', (e: { phone: string; contact_name: string | null }) => {
        const url = `/master-clients?search=${encodeURIComponent(e.phone)}&call_phone=${encodeURIComponent(e.phone)}`;
        window.open(url, '_blank');
      });
  }

  disconnect(): void {
    this.echo.disconnect();
  }
}
